import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/right-indent-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 19C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H21ZM20.6982 7.0127C21.0844 7.06414 21.4377 7.26506 21.6807 7.5752C21.92 7.88088 21.9654 8.22626 21.9824 8.41309C22.0008 8.61494 22 8.86226 22 9.09961V14.9004C22 15.1377 22.0008 15.3851 21.9824 15.5869C21.9654 15.7737 21.92 16.1191 21.6807 16.4248C21.4031 16.7792 20.9813 16.9906 20.5312 17C20.1431 17.0081 19.8394 16.8367 19.6797 16.7383C19.5071 16.6318 19.31 16.4823 19.1201 16.3398L15.2529 13.4404C15.1232 13.3431 14.9723 13.2307 14.8525 13.123C14.7281 13.0111 14.5447 12.8245 14.4355 12.5439C14.2995 12.1942 14.2995 11.8058 14.4355 11.4561L14.4795 11.3555C14.5894 11.1302 14.7436 10.975 14.8525 10.877C14.9723 10.7693 15.1232 10.6569 15.2529 10.5596L19.1201 7.66016C19.31 7.51773 19.5071 7.36817 19.6797 7.26172C19.8394 7.16326 20.1431 6.99193 20.5312 7L20.6982 7.0127ZM12 13.75C12.5523 13.75 13 14.1977 13 14.75C13 15.3023 12.5523 15.75 12 15.75H3C2.44772 15.75 2 15.3023 2 14.75C2 14.1977 2.44772 13.75 3 13.75H12ZM16.666 12L20 14.5V9.5L16.666 12ZM12 8.25C12.5523 8.25 13 8.69772 13 9.25C13 9.80228 12.5523 10.25 12 10.25H3C2.44772 10.25 2 9.80228 2 9.25C2 8.69772 2.44772 8.25 3 8.25H12ZM21 3C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5H3C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H21Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as RightIndent01Icon };
